<template>
	<div class="top-main">
		<div class="top-main-middle">
			<div class="account" @click="toAccount">
				<img src="../../static/young_account.png" alt="">
			</div>
			<div class="logo">
				<img src="../../static/young_white_logo.png" alt="">
			</div>
			<div class="lang">
				<div class="to-zh" @click="changeLang('zh')">

				</div>
				<div class="to-en" @click="changeLang('en')">

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'youngnavtop',
		data () {
			return {
				default_title_list_start: [
					{
						name: "首页",
						children: [],
						path: "/home"
					}
				],
				en_default_title_list_start: [
					{
						name: "Home",
						children: [],
						path: "/en_home"
					}
				],
				defalut_title_list_end: [
					// {
					// 	name: "参观留言",
					// 	children: [],
					// 	path: "/jslt"
					// }
				],
			}
		},
		mounted() {
			
		},
		methods: {
			toAccount() {
				let that = this
				var titleList = []
				that.$http.post({
					url: '/api/channel/findChannelTree/',
					data: {
						siteId: 1
					}
				}).then(res => {
					var titleList = []
					if(res.code === 'S200') {
						titleList.push(...that.default_title_list_start)
						titleList.push(...res.data)
						titleList.push(...that.defalut_title_list_end)
					}
					that.$store.state.titleList = titleList
					that.$store.state.lang = 'zh'
					that.$store.state.firstSelect = ''
					that.$store.state.secondSelect = ''
					that.$router.push('grxx')
				})
			},
			changeLang(lang) {
				let that = this
				that.$store.state.lang = lang
				that.$http.post({
					url: '/api/channel/findChannelTree/',
					data: {
						siteId: lang === 'zh' ? 1 : 3
					}
				}).then(res => {
					var titleList = []
					if(res.code === 'S200') {
						if(lang === 'zh') {
							titleList.push(...that.default_title_list_start)
							titleList.push(...res.data)
							titleList.push(...that.defalut_title_list_end)
							that.$store.state.titleList = titleList
							that.$router.push('/home')
						} else {
							titleList.push(...that.en_default_title_list_start)
							titleList.push(...res.data)
							that.$store.state.titleList = titleList
							that.$router.push('/en_home')
						}
					}
					
				})

			},
		}
	}
</script>

<style lang="less" scoped>
	.top-main {
		position: relative;
		height: 90px;
		width: 100%;
		min-width: 1500px;
		background-image: url(../../static/young_top.png);
		background-size: 100% 100%;
		z-index: 1001;
		.top-main-middle {
			width: 40%;
			height: 85px;
			margin: 0 auto;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			.account {
				width: 90px;
				height: 25px;
				margin-top: 27px;
				cursor: pointer;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.logo {
				width: 234px;
				height: 69px;
				margin-top: 13px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.lang {
				width: 152px;
				height: 25px;
				margin-top: 27px;
				background-image: url(../../static/young_lang.png);
				background-size: 100% 100%;
				display: flex;
				.to-zh {
					width: 40px;
					margin-left: 30px;
					height: 22px;
					cursor: pointer;
				}
				.to-en {
					width: 68px;
					margin-left: 10px;
					height: 22px;
					cursor: pointer;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/YoungNavTop.vue